import React from 'react';

// The thin colour band across the top of the site's public pages (styled by .home-stripe).
export default function TopStripe() {
  return <div className="home-stripe" aria-hidden="true" />;
}
